import React from 'react'
import { StoreWrap, api } from 'xadmin'
import { _t } from 'xadmin-i18n'
import { Button } from 'antd'

const LogOutComponent = StoreWrap('auth.user')(({ user, onLogout, ...props }) => {
  const { border, editMode, text, color, btnStyle } = props

  const style = { height: '100%' }

  if (color) style['color'] = color
  if (btnStyle) style['backgroundColor'] = btnStyle
  if (border) {
    style['border'] = 'none'
    style['boxShadow'] = 'none'
  }

  const getLogoutLog = e => {
    api({ name: 'core/auth/logout' }).fetch('')
  }
  // return null
  return (
    <div className="dashboard-button-container" style={{ width: '100%', height: '100%' }}>
      <Button className="dashboard-button" onClick={e => { !editMode && getLogoutLog(); !editMode && onLogout(); }} block style={style}>{text || '退出系统'}</Button>
    </div>
  )
})

const paramSchema = () => ({
  type: 'object',
  properties: {
    text: {
      title: '文字',
      type: 'string'
    },
    color: {
      title: '颜色',
      type: 'string',
      fieldType: 'color'
    },
    btnStyle: {
      title: '按钮样式',
      type: 'string',
      fieldType: 'color'
    },
    border: {
      title: '隐藏边框',
      type: 'boolean'
    },
  }
})

const LogOut = {
  title: '退出登录',
  category: '页面元素',
  icon: require('../icon/退出登录.svg'),
  component: LogOutComponent,
  initLayout: { width: 100, height: 80 },
  paramSchema,
  theme: [
    { selector: '.dashboard-button-container .dashboard-button', title: '退出登录样式及文字' },
    { selector: '.dashboard-button-container', title: '退出登录外层' },
  ]
}
export default LogOut